export const ACTIVITY_EVENT_TYPE = {
  NOTIFICATION_READ: "NOTIFICATION_READ",
  NOTIFICATION_UNREAD: "NOTIFICATION_UNREAD",
  CREATE_PROVIDER_RECORD: "CREATE_PROVIDER_RECORD",
  DELETE_PROVIDER_RECORD: "DELETE_PROVIDER_RECORD",
  UPDATE_PROVIDER_RECORD: "UPDATE_PROVIDER_RECORD",
  EXPORT_VIA_FHIR: "EXPORT_VIA_FHIR",
};

export const NOTIFICATION_TYPE = {
  REFERRAL_FLAGGED: "REFERRAL_FLAGGED",
  REFERRAL_UNFLAGGED: "REFERRAL_UNFLAGGED",
  DOCUMENT_ADDED_TO_PROCESS: "DOCUMENT_ADDED_TO_PROCESS",
  ADD_COMMENT: "ADD_COMMENT",
};

export const ACTIVITY_TYPE_NAME = {
  DOCSERVER_DOCUMENT: "DOCSERVER_DOCUMENT",
  RECEIVED_FAX_DOCUMENT: "RECEIVED_FAX_DOCUMENT",
  SERVICE_REQUEST: "SERVICE_REQUEST",
  SENTREFERRAL: "SENTREFERRAL",
  RCVDREFERRAL: "RCVDREFERRAL",
};
